import {
  helpers,
  required,
  minLength,
  maxLength,
  numeric,
  email
} from "vuelidate/lib/validators";
import moment from "moment";

const name = helpers.regex("name", /^[_A-z]*((-|\s)*[_A-z])*$/);
const phoneNumber = helpers.regex(
  "phoneNumber",
  /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
);

const validations = {
  fname: { required, name, min: minLength(2) },
  lname: { required, name, min: minLength(2) },
  address: { min: minLength(5) },
  city: { name, min: minLength(2) },
  postalCode: { required, numeric, min: minLength(5), max: maxLength(5) },
  phone: { phoneNumber, min: minLength(10) },
  email: { email, min: minLength(5) }
  // password1: { password1, min: minLength(8) },
  // password2: { password2, min: minLength(8) }
};

const rules = {
  fnameRules: [
    v => !!v || "First name is required",
    v =>
      (v && /^[_A-z]*((-|\s)*[_A-z])*$/.test(v)) ||
      "First name must only contain letters"
  ],
  lnameRules: [
    v => !!v || "Last name is required",
    v =>
      (v && /^[_A-z]*((-|\s)*[_A-z])*$/.test(v)) ||
      "Last name must only contain letters"
  ],
  streetAddressRules: [
    v =>
      (v && v.length >= 5) ||
      "Street address must contain at least 5 characters"
  ],
  cityRules: [
    v => (v && v.length >= 2) || "City must contain at least 2 characters"
  ],
  phoneRules: [
    v =>
      (v && /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(v)) ||
      "Phone number must be valid",
    v =>
      (v && v.length >= 10) ||
      "Phone number must contain at least 10 characters"
  ],
  emailRules: [
    v => (v && /\S+@\S+\.\S+/.test(v)) || "Email must be valid",
    v => (v && v.length >= 5) || "Email must contain at least 5 characters"
  ],
  postalCodeRules: [
    v => !!v || "Postal code is required",
    v => (v && /^\d+$/.test(v)) || "Postal code must only contain numbers",
    v => (v && v.length === 5) || "Postal code must be exactly 5 characters"
  ],
  messageBodyRules: [v => !!v || "Cannot send a blank message"],
  // password1Rules: [
  //   v =>
  //   !v
  //     ? null
  //     : (v && v.length >= 8) ||
  //       "Password must contain at least 8 characters",
  //   v => !!v || "Password is required",
  //   v => (v && /^[a-z]+/.test(v)) || "Pass must contain at least one lower case letter",
  //   v => (v && /^[A-Z]+/.test(v)) || "Pass must contain at least one upper case letter",

  // ],
  // password2Rules: [
  //   v =>
  //   !v
  //     ? null
  //     : (v && v.length >= 8) ||
  //       "Password must contain at least 8 characters"
  // ]
  dateRules: [
    v => !!v || "Date is required",
    v =>
      (v && moment(v, "YYYY-MM-DD").isValid()) ||
      "Invalid date format" + `<br>` + "Please use YYYY-MM-DD"
  ]
};

export default {
  validations,
  rules
};
